// pipe 4B.8b: the one seam that gates every native enhancement. Detect the Capacitor
// native bridge via the INJECTED global (Capacitor injects `window.Capacitor` into the
// WebView, incl. a remote server.url origin). NO static `import '@capacitor/core'` here,
// so the web main bundle is unchanged; the plugin code lives only in the lazy chunks the
// native adapters dynamic-import (one codebase, web bundle unchanged — CLAUDE.md #6).
export function isNative(): boolean {
  const cap = (globalThis as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return cap?.isNativePlatform?.() ?? false;
}
